/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import { BrowserCacheLocation } from "@azure/msal-browser";

const incomingQueryParams = new URLSearchParams(
  window ? window.location.search : ""
);
const incomingQueryParamsObject = Object.fromEntries(
  incomingQueryParams.entries()
);
const aadPolicy =
  incomingQueryParamsObject.bypass_sign_in === "true"
    ? process.env.REACT_APP_AAD_SIGN_UP_POLICY
    : process.env.REACT_APP_AAD_SIGN_IN_POLICY;

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AAD_CLIENT_ID,
    authority: `https://${process.env.REACT_APP_AAD_AUTHORITY}/${process.env.REACT_APP_AAD_TENANT_ID}/${aadPolicy}`,
    knownAuthorities: [process.env.REACT_APP_AAD_AUTHORITY],
    postLogoutRedirectUri: process.env.REACT_APP_AAD_REDIRECT_URI,
    redirectUri: process.env.REACT_APP_AAD_REDIRECT_URI,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage, // This configures where your cache will be stored
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    secureCookies: true,
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const tokenRequest = {
  scopes: [
    "https://brighterredact.onmicrosoft.com/b2537b0f-971f-4bfd-94e4-59d82383f418/scope",
  ],
  authority: `https://${process.env.REACT_APP_AAD_AUTHORITY}/${process.env.REACT_APP_AAD_TENANT_ID}/${aadPolicy}`,
  forceRefresh: true, // Set this to "true" to skip a cached token and go to the server to get a new token
};

export const redirectRequest = {
  scopes: tokenRequest.scopes,
  authority: tokenRequest.authority,
  // forward incoming parameters to login page
  extraQueryParameters: incomingQueryParamsObject,
};

export async function getAccessTokenSilent(msalClient, accountId) {
  if (!accountId) {
    return null;
  }

  let request = tokenRequest;
  request.account = msalClient.getAccountByHomeId(accountId);
  let authResult = await msalClient.acquireTokenSilent(request);
  return authResult;
}

export function getAccountId(msalClient) {
  const currentAccounts = msalClient.getAllAccounts();

  if (currentAccounts.length > 1) {
    return currentAccounts[0].homeAccountId;
  } else if (currentAccounts.length === 1) {
    return currentAccounts[0].homeAccountId;
  }

  return null;
}
